<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoginCallback',
  created() {
    this.oidcSignInCallback().then((redirectPath) => {
      this.$router.push(redirectPath)
    })
  },
  methods: {
    ...mapActions('oidc', ['oidcSignInCallback'])
  }
}
</script>
